import { useEffect, useState } from "react";
import { useRouter } from 'next/router';
import ListView from "../listview";
import _ from "lodash";
import Error from 'next/error';

const News = () => {
  const [typeID, setID] = useState();

  useEffect(() => {
    //get the type id from url path
    if (typeof window !== "undefined") {
      let path = window.location.pathname;
      let data = _.split(path, '/', 4);

      if (data[3] && data[3].length == 3) {
        setID(data[3]);
      } else {
        setID(null);
      }
    }
  }, []);

  if (typeID) {
    //normal
    return (<ListView topicID={typeID} />);
  } else if (typeID === null) {
    //type id not valid
    return <Error statusCode='404' />
  } else {
    return <></>
  }
  
}

export default News;